import './sentry'; // boshqa hamma narsadan OLDIN — erta xatolarni ham tutishi uchun
import React from 'react';
import ReactDOM from 'react-dom/client';
import axios from 'axios';
import './index.css';
import App from './App';
import store from './store';
import { logout } from './store/authSlice';
import reportWebVitals from './reportWebVitals';
import { initTheme } from './utils/darkMode';
import { initSelectOnFocus } from './utils/selectOnFocus';

// public/index.html'dagi inline skript allaqachon <html data-theme> ni
// birinchi bo'yoqdan (paint) OLDIN qo'ygan (FOUC'ni oldini olish uchun) —
// bu chaqiruv shunchaki React state'i shu bilan sinxronligini kafolatlaydi.
initTheme();
initSelectOnFocus();

const API = process.env.REACT_APP_API_URL || 'http://localhost:5000/api';

// Har bir so'rov boshlangan vaqtni belgilaydi — javob kelganda haqiqiy
// (tarmoq bilan BIRGA, foydalanuvchi ko'rgan) davomiylikni hisoblash uchun.
axios.interceptors.request.use((config) => {
  config.metadata = { startTime: Date.now() };
  return config;
});

// Sekin (osilib qolayotgan) so'rovlarni backendga (u yerdan Telegram'ga)
// xabar qiladi — FAQAT kuzatish, hech narsani abort qilmaydi va bu so'rovni
// asosiy oqim HECH QACHON kutmaydi (await yo'q, xato bo'lsa jimgina yutiladi).
// Chegara (5s) backend/src/utils/apiSeverity.js dagi bilan bir xil — aniq
// darajani (5s/10s/15s) backend o'zi belgilaydi, bu yerda faqat oldindan
// filtr (keraksiz so'rov yubormaslik uchun).
function reportSlowRequest(config, status, data) {
  const startTime = config?.metadata?.startTime;
  if (!startTime) return;
  const url = config.url || '';
  if (url.includes('/monitor/slow-client')) return; // o'zini kuzatmasin
  const duration = Date.now() - startTime;
  if (duration < 5000) return;
  let responsePreview = '';
  try { responsePreview = typeof data === 'string' ? data : JSON.stringify(data); } catch { /* ignore */ }
  axios.post(`${API}/monitor/slow-client`, {
    path: url.replace(config.baseURL || '', ''),
    method: (config.method || 'get').toUpperCase(),
    duration,
    status,
    response: (responsePreview || '').slice(0, 200),
  }).catch(() => {});
}

// Auto-logout when the server rejects our token (expired / revoked via
// tokenVersion). Skip auth endpoints so login/forgot errors are handled locally.
axios.interceptors.response.use(
  (res) => {
    reportSlowRequest(res.config, res.status, res.data);
    return res;
  },
  (error) => {
    reportSlowRequest(error.config, error.response?.status, error.response?.data);
    const status = error.response?.status;
    const url = error.config?.url || '';
    const isAuthCall = /\/auth\/(login|register|forgot-password|reset-password)/.test(url);
    if (status === 401 && localStorage.getItem('token') && !isAuthCall) {
      store.dispatch(logout());
    }
    return Promise.reject(error);
  }
);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();

// PWA — service worker'ni ro'yxatdan o'tkazish (ilovani install qilinadigan
// va oflayin app-shell ishlaydigan qiladi). Faqat productionda yoqamiz, chunki
// dev rejimida SW kesh hot-reload'ga xalaqit beradi.
if ('serviceWorker' in navigator && process.env.NODE_ENV === 'production') {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/service-worker.js').catch(() => {
      /* SW ro'yxatdan o'tmasa ilova baribir oddiy web sifatida ishlayveradi */
    });
  });
} else if ('serviceWorker' in navigator) {
  // Development — productionda 'serve -s build' bilan sinab ko'rilganda brauzerga
  // ro'yxatdan o'tib qolgan eski SW va keshlarni avtomatik tozalaymiz. Aks holda
  // u eski index.html/favicon'ni keshdan berib, koddagi o'zgarishlarni "yutib" yuboradi.
  navigator.serviceWorker.getRegistrations().then((regs) => regs.forEach((r) => r.unregister()));
  if (window.caches?.keys) {
    caches.keys().then((keys) => keys.forEach((k) => caches.delete(k)));
  }
}
